import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  linkTo?: string;
  textColor?: string;
}

const Logo = ({
  size = 'md',
  showText = true,
  className = '',
  linkTo = '/',
  textColor = 'text-gray-900',
}: LogoProps) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24',
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-4xl',
  };

  const LogoContent = () => (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Image */}
      <div className={`${sizeClasses[size]} relative`}>
        <img
          src="/android-chrome-192x192.png"
          alt="Mermaids Of The Moment Logo"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="flex flex-col">
          <span
            className={`font-heading font-bold ${textSizeClasses[size]} ${textColor} leading-tight`}
          >
            Mermaids
          </span>
          <span
            className={`font-heading font-medium text-sm ${textColor.includes('white') ? 'text-blue-200' : 'text-blue-600'} -mt-1`}
          >
            Of The Moment
          </span>
        </div>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="hover:opacity-80 transition-opacity">
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default Logo;
